import React, { useEffect, useRef } from 'react';
import { useApp } from '../context/AppContext';
import { Star } from 'lucide-react';

// 20 Google Maps-style reviews for Amorium Hotel
const REVIEWS = [
  {
    name: 'Mehmet Kaya',
    rating: 5,
    date: '1 hafta önce',
    text: 'Küre Dağları\'nın tam kalbinde inanılmaz bir konaklama. Fin Evi Ahşap odası muhteşemdi, sabah kahvaltısı harika. Personel son derece ilgili ve profesyoneldi. Kesinlikle tekrar geleceğiz!',
    text_en: 'An amazing stay in the heart of Küre Mountains. The Finnish Wooden House was spectacular, breakfast was excellent. Staff was extremely attentive and professional. We will definitely return!',
    initials: 'MK',
    color: '#1F3A2E',
    source: 'Google',
  },
  {
    name: 'Sarah Mitchell',
    rating: 5,
    date: '2 weeks ago',
    text: 'Absolutely breathtaking! The wooden house surrounded by pine forests was like a dream. Perfect escape from city life. The jacuzzi at night with stars overhead was unforgettable.',
    text_en: 'Absolutely breathtaking! The wooden house surrounded by pine forests was like a dream. Perfect escape from city life.',
    initials: 'SM',
    color: '#B08D57',
    source: 'Google',
  },
  {
    name: 'Fatma Öztürk',
    rating: 5,
    date: '3 hafta önce',
    text: 'Mükemmel bir konaklama deneyimi. Odalar çok temiz ve konforlu. Doğa içinde bu kadar lüks bir yer bulmak gerçekten nadir. Fin Evi Suite, balayımız için biçilmiş kaftandı.',
    text_en: 'Excellent accommodation experience. Rooms are very clean and comfortable. It is truly rare to find such a luxurious place in nature.',
    initials: 'FÖ',
    color: '#3E5A3F',
    source: 'Google',
  },
  {
    name: 'Klaus Werner',
    rating: 5,
    date: '1 month ago',
    text: 'Exceptional boutique hotel experience! The stone building rooms had a wonderful historic charm while being fully modern. The view of the mountains from our balcony was incredible.',
    text_en: 'Exceptional boutique hotel experience! The stone building rooms had wonderful charm.',
    initials: 'KW',
    color: '#B07A5A',
    source: 'Google',
  },
  {
    name: 'Ayşe Demir',
    rating: 5,
    date: '2 hafta önce',
    text: 'Hayatımda gittiğim en güzel otellerden biri. Çam ormanları arasında yükselen fin evleri, akşam yaktığımız şömine... Adeta masalı bir deneyim. Personel bir aile gibi karşıladı bizi.',
    text_en: 'One of the most beautiful hotels I have ever visited. Finnish houses rising among pine trees, the fireplace we lit in the evening... A fairy tale experience.',
    initials: 'AD',
    color: '#1F3A2E',
    source: 'Google',
  },
  {
    name: 'Maria Gonzalez',
    rating: 5,
    date: '3 weeks ago',
    text: 'A hidden gem in Turkey! Amorium Hotel exceeded all expectations. The combination of Finnish architecture and Turkish hospitality is unique. The forest walks were magical.',
    text_en: 'A hidden gem in Turkey! Amorium Hotel exceeded all expectations. The forest walks were magical.',
    initials: 'MG',
    color: '#B08D57',
    source: 'Google',
  },
  {
    name: 'Ali Yıldız',
    rating: 4,
    date: '1 ay önce',
    text: 'Taş Bina Prestij Odası muhteşemdi. Vadi manzarası ve özel jakuzi ile tam bir kaçış ortamı. Sadece şehre biraz uzak, ama bu zaten otelini en değerli yapan şey.',
    text_en: 'The Stone Building Prestige Room was magnificent. Valley view and private jacuzzi created a perfect escape. A bit far from the city, but that\'s exactly what makes it special.',
    initials: 'AY',
    color: '#3E5A3F',
    source: 'Google',
  },
  {
    name: 'Emma Thompson',
    rating: 5,
    date: '2 months ago',
    text: 'We stayed for our honeymoon and it was perfect! The Finnish Suite had everything - outdoor jacuzzi, fireplace, private terrace with mountain views. Highly recommend for couples.',
    text_en: 'Perfect honeymoon destination! Finnish Suite with outdoor jacuzzi, fireplace, private terrace with mountain views.',
    initials: 'ET',
    color: '#B07A5A',
    source: 'Google',
  },
  {
    name: 'Zeynep Arslan',
    rating: 5,
    date: '3 hafta önce',
    text: 'İki çocuklu aile olarak geldik, Taş Bina Aile Odası mükemmeldi. Çocuklar doğada koşup oynadı, biz de dinlendik. Kahvaltı çok çeşitliydi ve her şey tazeydi. Teşekkürler Amorium!',
    text_en: 'We came as a family with two children, the Stone Building Family Room was excellent. Kids played in nature while we relaxed. Breakfast was varied and everything was fresh.',
    initials: 'ZA',
    color: '#1F3A2E',
    source: 'Google',
  },
  {
    name: 'Pierre Dubois',
    rating: 5,
    date: '1 month ago',
    text: 'Magnifique! Coming from France, I was amazed by this place. The mix of Scandinavian wooden architecture with Turkish mountain landscape is extraordinary. Best hotel I visited in Turkey.',
    text_en: 'The mix of Scandinavian wooden architecture with Turkish mountain landscape is extraordinary. Best hotel in Turkey.',
    initials: 'PD',
    color: '#B08D57',
    source: 'Google',
  },
  {
    name: 'Hasan Çelik',
    rating: 5,
    date: '5 gün önce',
    text: 'İş seyahatlerimde bile bu otele geliyorum artık. Fin Evi Ahşap odanın huzuru çok farklı bir şey. Dijital detoks için mükemmel. Geceler çok sakin, sabahlar büyüleyici.',
    text_en: 'I now come to this hotel even on business trips. The tranquility of the Finnish Wooden House room is something different. Perfect for digital detox.',
    initials: 'HÇ',
    color: '#3E5A3F',
    source: 'Google',
  },
  {
    name: 'Jennifer Adams',
    rating: 5,
    date: '6 weeks ago',
    text: 'Outstanding experience! Clean, luxurious, and surrounded by incredible nature. The staff speak excellent English and were incredibly helpful. Breakfast spread was amazing.',
    text_en: 'Outstanding experience! Clean, luxurious, surrounded by incredible nature. Breakfast spread was amazing.',
    initials: 'JA',
    color: '#B07A5A',
    source: 'Google',
  },
  {
    name: 'Osman Şahin',
    rating: 5,
    date: '2 hafta önce',
    text: 'Kastamonu bölgesinde bu kadar kaliteli bir konaklama yeri bulmak gerçekten sürpriz oldu. Küre Dağları\'nın eşsiz doğasıyla bütünleşmiş mimari tasarım çok etkileyici.',
    text_en: 'Finding such a quality accommodation in Kastamonu was truly a surprise. The architectural design integrated with the unique nature of Küre Mountains is very impressive.',
    initials: 'OŞ',
    color: '#1F3A2E',
    source: 'Google',
  },
  {
    name: 'Anna Kowalski',
    rating: 5,
    date: '1 month ago',
    text: 'Dreamy! We came from Poland for this place after seeing photos online. Reality was even better than pictures. The Finnish wooden house in the pine forest was magical.',
    text_en: 'Dreamy! Reality was even better than pictures. The Finnish wooden house in the pine forest was magical.',
    initials: 'AK',
    color: '#B08D57',
    source: 'Google',
  },
  {
    name: 'Selin Aydın',
    rating: 4,
    date: '1 ay önce',
    text: 'Romantik bir hafta sonu için mükemmel. Şömineli Fin Evi, huzurlu orman sesi ve muhteşem kahvaltı. Sadece şehirden araçla gelmek gerekiyor, ama her zaman değer.',
    text_en: 'Perfect for a romantic weekend. Finnish house with fireplace, peaceful forest sounds, and magnificent breakfast. Worth the drive from the city.',
    initials: 'SA',
    color: '#3E5A3F',
    source: 'Google',
  },
  {
    name: 'Thomas Müller',
    rating: 5,
    date: '3 weeks ago',
    text: 'Wunderbar! As a German traveler, I expected good service but Amorium Hotel surpassed all expectations. The quality of the wooden architecture and stone buildings is world-class.',
    text_en: 'Wunderbar! Surpassed all expectations. Quality wooden architecture and stone buildings are world-class.',
    initials: 'TM',
    color: '#B07A5A',
    source: 'Google',
  },
  {
    name: 'Burak Erdoğan',
    rating: 5,
    date: '1 hafta önce',
    text: 'Yıldönümümüz için geldik ve hayatımızın en güzel hafta sonunu geçirdik. Fin Evi Suite\'in açık hava jakuzisi gece gökyüzü altında unutulmaz bir deneyim sundu.',
    text_en: 'We came for our anniversary and had the best weekend of our lives. The outdoor jacuzzi of the Finnish Suite under the night sky was an unforgettable experience.',
    initials: 'BE',
    color: '#1F3A2E',
    source: 'Google',
  },
  {
    name: 'Sophie Laurent',
    rating: 5,
    date: '2 months ago',
    text: 'C\'est magnifique! Hidden away in Turkish mountains, this hotel is a treasure. The historic stone building room had authentic charm. Fresh mountain air and absolute tranquility.',
    text_en: 'Hidden away in Turkish mountains, this hotel is a treasure. Fresh mountain air and absolute tranquility.',
    initials: 'SL',
    color: '#B08D57',
    source: 'Google',
  },
  {
    name: 'Nilüfer Polat',
    rating: 5,
    date: '3 hafta önce',
    text: 'Doğayla iç içe, lüksü elden bırakmayan harika bir otel. Çam ormanları arasında Fin evleri hem görsel olarak hem de konfor açısından mükemmel. Personel çok samimi.',
    text_en: 'A wonderful hotel that does not compromise luxury while being in nature. Finnish houses among pine forests are perfect both visually and in terms of comfort.',
    initials: 'NP',
    color: '#3E5A3F',
    source: 'Google',
  },
  {
    name: 'David Chen',
    rating: 5,
    date: '1 month ago',
    text: 'Came all the way from Singapore and it was absolutely worth it. Unique blend of Finnish cabin aesthetics with Turkish hospitality. The forest views and mountain air were healing.',
    text_en: 'Came from Singapore, absolutely worth it. Unique blend of Finnish cabin aesthetics with Turkish hospitality. Forest views and mountain air were healing.',
    initials: 'DC',
    color: '#B07A5A',
    source: 'Google',
  },
];

function StarRating({ rating }) {
  return (
    <div style={{ display: 'flex', gap: '2px', marginBottom: '6px' }}>
      {[1, 2, 3, 4, 5].map(i => (
        <Star
          key={i}
          size={13}
          style={{ color: i <= rating ? '#F59E0B' : '#D1D5DB', fill: i <= rating ? '#F59E0B' : 'none' }}
        />
      ))}
    </div>
  );
}

export default function ReviewsSection() {
  const { language } = useApp();
  const scrollRef = useRef(null);

  // Duplicate reviews for infinite scroll effect
  const allReviews = [...REVIEWS, ...REVIEWS];

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    let animFrame;
    let position = 0;
    const speed = 0.5; // px per frame
    const singleWidth = el.scrollWidth / 2;

    const animate = () => {
      position += speed;
      if (position >= singleWidth) {
        position = 0;
      }
      el.scrollLeft = position;
      animFrame = requestAnimationFrame(animate);
    };

    animFrame = requestAnimationFrame(animate);

    const pause = () => cancelAnimationFrame(animFrame);
    const resume = () => { animFrame = requestAnimationFrame(animate); };

    el.addEventListener('mouseenter', pause);
    el.addEventListener('mouseleave', resume);
    el.addEventListener('touchstart', pause, { passive: true });
    el.addEventListener('touchend', resume);

    return () => {
      cancelAnimationFrame(animFrame);
      el.removeEventListener('mouseenter', pause);
      el.removeEventListener('mouseleave', resume);
    };
  }, []);

  return (
    <section style={{ background: '#1F3A2E', padding: '5rem 0', overflow: 'hidden' }}>
      {/* Header */}
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1.5rem', marginBottom: '3rem', textAlign: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', marginBottom: '12px' }}>
          {/* Google Logo SVG */}
          <svg width="80" height="28" viewBox="0 0 272 92" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M115.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18C71.25 34.32 81.24 25 93.5 25s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44S80.99 39.2 80.99 47.18c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z" fill="white"/>
            <path d="M163.75 47.18c0 12.77-9.99 22.18-22.25 22.18s-22.25-9.41-22.25-22.18c0-12.85 9.99-22.18 22.25-22.18s22.25 9.32 22.25 22.18zm-9.74 0c0-7.98-5.79-13.44-12.51-13.44s-12.51 5.46-12.51 13.44c0 7.9 5.79 13.44 12.51 13.44s12.51-5.55 12.51-13.44z" fill="white"/>
            <path d="M209.75 26.34v39.82c0 16.38-9.66 23.07-21.08 23.07-10.75 0-17.22-7.19-19.66-13.07l8.48-3.53c1.51 3.61 5.21 7.87 11.17 7.87 7.31 0 11.84-4.51 11.84-13v-3.19h-.34c-2.18 2.69-6.38 5.04-11.68 5.04-11.09 0-21.25-9.66-21.25-22.09 0-12.52 10.16-22.26 21.25-22.26 5.29 0 9.49 2.35 11.68 4.96h.34v-3.61h9.25zm-8.56 20.92c0-7.81-5.21-13.52-11.84-13.52-6.72 0-12.35 5.71-12.35 13.52 0 7.73 5.63 13.36 12.35 13.36 6.63 0 11.84-5.63 11.84-13.36z" fill="white"/>
            <path d="M225 3v65h-9.5V3h9.5z" fill="white"/>
            <path d="M262.02 54.48l7.56 5.04c-2.44 3.61-8.32 9.83-18.48 9.83-12.6 0-22.01-9.74-22.01-22.18 0-13.19 9.49-22.18 20.92-22.18 11.51 0 17.14 9.16 18.98 14.11l1.01 2.52-29.65 12.28c2.27 4.45 5.8 6.72 10.75 6.72 4.96 0 8.4-2.44 10.92-6.14zm-23.27-7.98l19.82-8.23c-1.09-2.77-4.37-4.7-8.23-4.7-4.95 0-11.84 4.37-11.59 12.93z" fill="white"/>
            <path d="M35.29 41.41V32H67c.31 1.64.47 3.58.47 5.68 0 7.06-1.93 15.79-8.15 22.01-6.05 6.3-13.78 9.66-24.02 9.66C16.32 69.35.36 53.89.36 34.91.36 15.93 16.32.47 35.3.47c10.5 0 17.98 4.12 23.6 9.49l-6.64 6.64c-4.03-3.78-9.49-6.72-16.97-6.72-13.86 0-24.7 11.17-24.7 25.03 0 13.86 10.84 25.03 24.7 25.03 8.99 0 14.11-3.61 17.39-6.89 2.66-2.66 4.41-6.46 5.1-11.65l-22.49.01z" fill="white"/>
          </svg>
          <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: '15px', fontWeight: 500, marginLeft: '4px' }}>Reviews</span>
        </div>
        <div style={{ display: 'inline-block', background: '#B08D57', height: '2px', width: '40px', marginBottom: '16px' }} />
        <h2 style={{
          fontFamily: 'Cormorant Garamond, Georgia, serif',
          fontSize: 'clamp(28px, 4vw, 40px)',
          fontWeight: 600,
          color: '#FFFFFF',
          marginBottom: '8px',
          lineHeight: 1.2,
        }}>
          {language === 'tr' ? 'Bizi Tercih Edenler' : 'What Our Guests Say'}
        </h2>
        <p style={{ fontSize: '14px', color: 'rgba(255,255,255,0.6)' }}>
          {language === 'tr'
            ? 'Hakkımızda bunları söyledi'
            : 'Reviews from guests around the world'}
        </p>
        {/* Rating summary */}
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '12px', marginTop: '16px' }}>
          <span style={{ fontSize: '36px', fontWeight: 700, color: '#F59E0B' }}>4.9</span>
          <div>
            <div style={{ display: 'flex', gap: '3px', marginBottom: '2px' }}>
              {[1,2,3,4,5].map(i => (
                <Star key={i} size={16} style={{ color: '#F59E0B', fill: '#F59E0B' }} />
              ))}
            </div>
            <p style={{ fontSize: '12px', color: 'rgba(255,255,255,0.6)' }}>
              {language === 'tr' ? `${REVIEWS.length}+ Google yorumu` : `${REVIEWS.length}+ Google reviews`}
            </p>
          </div>
        </div>
      </div>

      {/* Auto-scroll carousel */}
      <div
        ref={scrollRef}
        style={{
          display: 'flex',
          gap: '16px',
          overflowX: 'hidden',
          scrollBehavior: 'auto',
          paddingBottom: '8px',
          cursor: 'grab',
          WebkitOverflowScrolling: 'touch',
        }}
      >
        {allReviews.map((review, idx) => (
          <div
            key={idx}
            style={{
              flexShrink: 0,
              width: '300px',
              background: 'rgba(255,255,255,0.05)',
              border: '1px solid rgba(255,255,255,0.1)',
              borderRadius: '16px',
              padding: '20px',
              backdropFilter: 'blur(10px)',
            }}
          >
            {/* Header */}
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
              <div style={{
                width: '40px', height: '40px', borderRadius: '50%',
                background: review.color,
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                color: 'white', fontSize: '14px', fontWeight: 700, flexShrink: 0,
              }}>
                {review.initials}
              </div>
              <div style={{ flex: 1, minWidth: 0 }}>
                <p style={{ fontWeight: 600, fontSize: '14px', color: 'white', marginBottom: '1px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {review.name}
                </p>
                <p style={{ fontSize: '11px', color: 'rgba(255,255,255,0.5)' }}>{review.date}</p>
              </div>
              {/* Google G icon */}
              <svg width="18" height="18" viewBox="0 0 24 24" style={{ flexShrink: 0, opacity: 0.7 }}>
                <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
                <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
                <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
                <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
              </svg>
            </div>

            <StarRating rating={review.rating} />

            <p style={{
              fontSize: '13px',
              lineHeight: '1.6',
              color: 'rgba(255,255,255,0.8)',
              display: '-webkit-box',
              WebkitLineClamp: 4,
              WebkitBoxOrient: 'vertical',
              overflow: 'hidden',
            }}>
              {language === 'tr' ? review.text : (review.text_en || review.text)}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
